// extracted by mini-css-extract-plugin
export var container = "_vg-0";
export var table = "_vg-2";
export var tableWrapper = "_vg-1";